import { theme } from '@hiver/hiver-ui-kit';

export function getSmEmailId(sm, isgagroup) {
    const { gagroupemail, sourceuser, active } = sm;
    const isSmActive = parseInt(active);
    const isGaGroup = parseInt(isgagroup);
    if (sourceuser && !isGaGroup && isSmActive === 1 ) {
      return sourceuser.email;
    }
    return gagroupemail;
}

//replace the input string having format ${} with their corresponding replacement value array.
//works similar to string.format() in python
export const formatString = (str, replacements) => (str.replace(/\$\{\}/g, () => replacements.shift()));

export const getDomainFromEmailAddress = (emailAddress) =>{
  if (emailAddress) {
      const domain = emailAddress.split('@')[1];
      return domain;
    }
    return null;
}

export const isNumberInput = (value, setStateValue) => {
  const numRegex = new RegExp(/^\d*$/,'i');
  if(numRegex.test(value)){
      setStateValue(Number(value));
      return true;
  }
  return false;
}

/**
 * Scrolls the container to the element with id as elemId
 * @param {string} elemId Id of element to be scrolled too
 * @param {boolean} highlight Setting true highlights element after scroll with default color - hiver primary
 * @param {Object} additionalParams extra styling params to be passed ex: {color: "#FFE250"}
 */
export const scrollToElement = (elemId, highlight=false, additionalParams={})=>{
  setTimeout(()=>{
    const element = document.getElementById(elemId);
    element?.scrollIntoView({ behavior: 'smooth', block: 'center' , inline: 'nearest'});
    if(highlight) highlightElement(elemId, additionalParams);
  },1000)
}

/**
 * Highlights the container with id as elemId with default color as hiver primary
 * @param {string} elemId Id of element to be highlighted
 * @param {Object} additionalParams extra styling params to be passed ex: {color: "#FFE250"}
 */
export const highlightElement = (elemId, additionalParams={}) => {
  const element = document.getElementById(elemId);
  const color = additionalParams.color || theme.palette.yellow.primary;
  const opacity = additionalParams.opacity || 1;
  const visibility = additionalParams.visibility || "visible";
  // Apply inline styles to highlight the element
  element.style.cssText = `visibility: ${visibility}; background-color: ${color}; opacity: ${opacity}; transition: background-color 1s ease-in-out, opacity 1s ease-in-out;`;
  // Remove the highlight after a delay
  setTimeout(() => {
    element.style.cssText = '';
  }, 2000);
};
/*
 * removes unwanted unicode whitespace characters from the input but keeps standard space character \u0020
 * @param {String} input 
 * @returns String
 */
export const removeUnicodeWhitespaceCharacters = (input) => {
  try {
    // regex to find unicode whitespace characters
    const whitespaceRegex = /[\u0085\u00A0\u1680\u2000-\u200B\u2028\u2029\u202F\u205F\u3000\u2800]/gu;
    return input.replaceAll(whitespaceRegex, "");
  } catch (error) {
    console.error(error)
    return input
  }
}

/**
 * removes unwanted unicode whitespace characters from each input of the input list
 * @param {String[]} inputList 
 * @returns String[]
 */
export const removeUnicodeWhitespaceCharactersFromListEntries = (inputList) => {
  try {
    return inputList.map((value)=> {
      return typeof value === "string" ? removeUnicodeWhitespaceCharacters(value) : value
    }).filter(value=> typeof value === "string" ? value.length > 0 : true)
  } catch (error) {
    console.error(error)
    return inputList
  }
}
